module.exports = __webpack_public_path__ + "static/media/mj-apple-pay.2c99053f.svg";